import { ReactNode } from 'react';

import AccessLabel from '@/security/components/AccessLabel/AccessLabel';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { AccessTargetType } from '@/security/types/AccessTarget';

import GlobalAccessRadio from '../GlobalAccessRadio/GlobalAccessRadio';

import styles from './GlobalAccessLevelRadio.module.css';

export interface GlobalAccessLevelRadioProps {
  access: GlobalAccessLevel;
  checked: boolean;
  description?: ReactNode;
  disabled?: boolean;
  isAmbient?: boolean;
  onChange: (id: GlobalAccessLevel) => void;
  title: ReactNode;
  type: AccessTargetType;
  'aria-label'?: string;
}

function GlobalAccessLevelRadio(props: GlobalAccessLevelRadioProps) {
  const {
    access,
    checked,
    description,
    disabled = false,
    isAmbient = false,
    onChange,
    title,
    type,
    'aria-label': ariaLabel,
  } = props;

  return (
    <GlobalAccessRadio
      aria-label={ariaLabel}
      checked={checked}
      description={description}
      disabled={disabled}
      icon={<AccessLabel access={access} className={styles.optionIcon} type={type} />}
      isAmbient={isAmbient}
      onChange={() => onChange(access)}
      title={title}
    />
  );
}

export default GlobalAccessLevelRadio;
